import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_licenseplates_by_containerTypeId_top1Service {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { containerTypeId: number }): 
  Promise<{ result: { Id?: number, LicensePlateContainerTypeId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.containerTypeId)) {
      missingRequiredInParams.push('\'containerTypeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_licenseplates_by_containerTypeId_top1/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

